import { useTranslation } from 'react-i18next';
import { useHelpModalState } from 'react-commons';
import { useHistory } from 'react-router';
import useGetTitle from './useGetTitle';
import useGetListItems from './useGetListItems';
import useCalculatePreResult from './useCalculatePreResult';
import { useStyles } from '../../Shared';
import { useGlobalState } from '../../../state/persistence';

const usePreResult = (nextUrl: string) => {
  const { t } = useTranslation('pre_result');
  const { toggleHelpModal } = useHelpModalState();
  const history = useHistory();
  const preResultAmount = useCalculatePreResult();
  const titleComp = useGetTitle(t, preResultAmount);
  const listItems = useGetListItems(t);

  return {
    t,
    toggleHelpModal,
    onSubmit: () => history.push(nextUrl),
    titleComp,
    listItems,
    classes: useStyles(),
  };
};

export default usePreResult;
